module.exports = __webpack_public_path__ + "img/CreekCleanup-1.db43cc36.jpg";